export default "__VITE_ASSET__DLlI4fdE__"